import authentication from "@irati/auth"
import {Team, TeamState} from "@irati/types"
import FeatureFlags from "@irati/types/featureFlags"
import teamsService from "../../services/teams"

export default async function hasMultipleOffices(business = authentication.business()): Promise<boolean> {
  const offices = await officesForTenant(business)
  return currentlySupportedTeamSetups(offices).length > 1
}

export async function officesForTenant(business = authentication.business(), enabled: boolean): Promise<Team[]> {
  const offices = await teamsService.list(business.uuid, {state: TeamState.BillingUnit, enabled})

  if (offices.length > 1 || !!authentication.apps("admin.billingUnit")) {
    return offices
  }
  return []
}

export function officeForUser(business = authentication.business(), user = authentication.user()): Promise<Team | null> {
  return officesForTenant(business).then((offices) => {
    const billingUnit = offices.find((team) => user.teamIds.find((teamId) => teamId === team.uuid))

    return billingUnit || null
  })
}

function currentlySupportedTeamSetups(teams: Team[]) {
  // currently only show offices if the tenant has teams with perks permissions assigned to them
  return teams.filter((test) => test?.featureFlags?.includes(FeatureFlags.PerksEnabledForTeam))
}
